type SortableCollection = { startDate?: Date | null; name?: string | null }

/**
 * Collection ordering: startDate ascending (a missing date sorts to the top), ties broken by name.
 *
 * Shared so the cache merge in `cacheUtils/collectionCacheHelpers` orders exactly as the server
 * does — AG-Grid rows reorder on a partial refresh if the two diverge.
 */
export const sortCollectionsByStartThenName = (a: SortableCollection, b: SortableCollection) => {
  const dateComparison = (a.startDate?.getTime() ?? 0) - (b.startDate?.getTime() ?? 0)
  return dateComparison === 0 ? (a.name ?? "").localeCompare(b.name ?? "") : dateComparison
}
